import { styled } from "@mui/material";

export const CustomA = styled('a')(({ theme }) => ({
    textDecoration: 'none',
    color: 'inherit',
    transition: 'font-weight 0.2s ease',
    '&:hover': {
      fontWeight: 'bold',
    },
  }));